"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyConstraint = void 0;
const class_validator_1 = require("class-validator");
function PropertyConstraint(predicate, validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "propertyConstraint",
            target: object.constructor,
            propertyName: propertyName,
            constraints: [predicate],
            options: validationOptions,
            validator: {
                validate(value, args) {
                    if (value == null)
                        return false;
                    return Object.keys(value).every(k => predicate(k));
                },
            },
        });
    };
}
exports.PropertyConstraint = PropertyConstraint;
//# sourceMappingURL=PropertyConstraint.js.map